import {
    REGISTER_EMAIL_CHECK,
    REGISTER_EMAIL_CHECK_SUCCESS,
    REGISTER_PHONE_CHECK,
    REGISTER_PHONE_CHECK_SUCCESS,
    REGISTER_USER,
    REGISTER_SUCCESS,
    API_ERROR,
    REGISTER_EMAIL_CHECK_FAILURE,
    RESET_API_ERROR,
  } from "./ActionTypes";


  //email check

  export const registerEmailCheck = (values) => {
    return {
      type: REGISTER_EMAIL_CHECK,
      payload: { values },
    };
  };

  export const registerEmailCheckSuccess = emailId => {
    return {
      type: REGISTER_EMAIL_CHECK_SUCCESS,
      payload: emailId,
    };
  };

  export const registerEmailCheckFailure = emailId => {
    return {
      type: REGISTER_EMAIL_CHECK_FAILURE,
      payload: emailId,
    };
  };

   //phone check

   export const registerPhoneCheck = (phoneNumber) => {
    return {
      type: REGISTER_PHONE_CHECK,
      payload: { phoneNumber },
    };
  };

  export const registerPhoneCheckSuccess = (phoneNumber) => {
    return {
      type: REGISTER_PHONE_CHECK_SUCCESS,
      payload: { phoneNumber },
    };
  };


  //register form
  
  export const registerUser = (user, history) => {
    return {
      type: REGISTER_USER,
      payload: { user, history },
    };
  };
  
  export const registerSuccess = user => {
    return {
      type: REGISTER_SUCCESS,
      payload: user,
    };
  };
  
  export const apiError = error => {
    return {
      type: API_ERROR,
      payload: error,
    };
  };

  export const restApiError = () => {
    return {
      type: RESET_API_ERROR,
    };
  };